import { h } from "preact";
function CartItemPrice({ price }) {
    return (h("div", { class: "item__price" },
        h("strong", null, price)));
}
export default CartItemPrice;
